import { withStyles } from '@material-ui/core';
const styles = (theme) => ({
  kpiHeader: {
    color: theme.TextColor,
    textAlign: 'center',
    fontSize: 22,
    lineHeight: '30px',
    fontWeight: 600
  },
  kpiHeaderString: {
    color: theme.TextColor,
    textAlign: 'center',
    fontSize: 20,
    lineHeight: '30px',
    fontWeight: 600
  },
  kpiLabel: {
    color: theme.TextColor,
    textAlign: 'center',
    fontSize: 14,
    fontWeight: 400
  },
  kpiLabelString: {
    color: theme.TextColor,
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 400,
    padding: '0 1'
  },
  kpiContainer: { display: 'flex', alignItems: 'baseline', justifyContent: 'center' }
});

const TimeString = ({ minutes, classes }) => {
  if (minutes >= 60) {
    return (
      <div className={classes.kpiContainer}>
        <span className={classes.kpiHeaderString}>{Math.floor(minutes / 60)}</span>
        <span className={classes.kpiLabelString}>hr</span>
        <span className={classes.kpiHeaderString}>{minutes % 60}</span>
        <span className={classes.kpiLabelString}>min</span>
      </div>
    );
  } else {
    return (
      <div className={classes.kpiContainer}>
        <span className={classes.kpiHeader}>{minutes}</span>
        <span className={classes.kpiLabel}>min</span>
      </div>
    );
  }
};

export default withStyles(styles)(TimeString);
